import {useSignals} from '@preact/signals-react/runtime'
import {ReactComponent as ReloadIcon} from '../../assets/icons/ReloadIcon.svg'
import {ReactComponent as TableLock} from '../../assets/icons/TableLock.svg'
import {ReactComponent as PDFIcon} from '../../assets/icons/pdfIcon.svg'
import {ReactComponent as ColumnEdit} from '../../assets/menu/ColumnEdit.svg'
// import {ReactComponent as ClearFilterIcon} from '../../assets/icons/ClearFilter.svg'

import {useRef} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {useAuth} from '../authentication/AuthProvider'
import {clearCache} from '../cache/CacheEndPoint'
import {tableToolBarDescriptionList} from './Constant'
import {useDatatableContext} from './DataTableContext'
import StyledDataExchange from './StyledDataExchange'
import StyledLockDataTable from './StyledLockDataTable'
import StyledToolbarIcon from './StyledToolbarIcon'
import StyledViewedColumns from './StyledViewedColumns'
import {
    onItemTableToolBarSelectedListener,
    tableToolBarEventTypes,
} from './broadcast/TableToolBarEvent'

const StyledTableControlToolBar = () => {
    useSignals()

    //#region Hooks
    const {translateDatatable} = TranslateUtils()
    //#endregion

    //#region DataTable Context
    const {user} = useAuth()
    const {tableType, handleRefeshTable} = useDatatableContext()
    //#endregion

    const onClearCache = async () => {
        await clearCache(user?.id)
    }

    const viewedColumnsRef = useRef(null)
    const lockColumns = useRef(null)
    const dataExchangeRef = useRef(null)

    return (
        <div className="container">
            <h6 className="toggle-group-label font-bold m-0  px-2 mb-1">
                {translateDatatable('Table Controls')}
            </h6>
            <div className="custom-toolbar-items-wrapper  py-0 pr-2">
                <StyledToolbarIcon
                    icon={<ColumnEdit />}
                    label={translateDatatable('Column Visibility')}
                    description={tableToolBarDescriptionList.editColumn}
                    onClick={() => {
                        viewedColumnsRef.current.showForm()

                        onItemTableToolBarSelectedListener(
                            tableType,
                            tableToolBarEventTypes.ON_ITEM_SELECTED,
                            'Column Visibility',
                        )
                    }}
                />
                <StyledToolbarIcon
                    icon={<TableLock />}
                    label={translateDatatable('Lock Columns')}
                    description={tableToolBarDescriptionList.lockColumn}
                    onClick={() => {
                        lockColumns.current.showForm()

                        onItemTableToolBarSelectedListener(
                            tableType,
                            tableToolBarEventTypes.ON_ITEM_SELECTED,
                            'Lock Columns',
                        )
                    }}
                />
                <StyledToolbarIcon
                    icon={<PDFIcon />}
                    label={translateDatatable('Import/Export')}
                    description={tableToolBarDescriptionList.export}
                    onClick={() => {
                        dataExchangeRef.current.showForm(tableType)

                        onItemTableToolBarSelectedListener(
                            tableType,
                            tableToolBarEventTypes.ON_ITEM_SELECTED,
                            'Import/Export',
                        )
                    }}
                />
                <StyledToolbarIcon
                    icon={<ReloadIcon />}
                    label={translateDatatable('Refresh')}
                    description={tableToolBarDescriptionList.refresh}
                    onClick={() => {
                        onClearCache()

                        onItemTableToolBarSelectedListener(
                            tableType,
                            tableToolBarEventTypes.ON_ITEM_SELECTED,
                            'Import/Export',
                        )
                    }}
                />
            </div>

            <StyledViewedColumns ref={viewedColumnsRef} />

            <StyledLockDataTable ref={lockColumns} />

            <StyledDataExchange ref={dataExchangeRef} />
        </div>
    )
}

export default StyledTableControlToolBar
